
















module.exports = {
  "countdown":   {
    "countdown": () => import("../countdown/countdown.js")
  },
  "election-results":   {
    "elected-connetables": () => import("../election-results/elected-connetables.js"),
    "elected-deputies-slider": () => import("../election-results/elected-deputies-slider.js"),
    "elected-deputies": () => import("../election-results/elected-deputies.js"),
    "election-results": () => import("../election-results/election-results.js"),
    "last-modified": () => import("../election-results/last-modified.js")
  },
  "global":   {
    "site-search": () => import("../global/site-search.js")
  },
  "infinite-list":   {
    "infinite-list": () => import("../infinite-list/infinite-list.js")
  },
  "table":   {
    "table": () => import("../table/table.js")
  },
  "header":   {
    "nav-primary":     {
      "nav-primary": () => import("../header/nav-primary/nav-primary.js")
    }
  }
}